/* eslint-disable react/prop-types */
import React, { useState, SFC, useEffect, useRef } from "react";
import {
    Card,
    Grid,
    Box,
    Typography,
    TextField,
    Button,
    GridJustification,
    useTheme,
    useMediaQuery,
    PropTypes as MuIPropTypes,
    CircularProgress,
} from "@material-ui/core";
import {TextField as RTextField} from "formik-material-ui";
import { makeStyles } from "@material-ui/core/styles";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import { useSnackbar } from "notistack";
import { useHistory } from "react-router-dom";
import {colorBorder, colorfff, colorPrimary, colorSecondary} from "../../Constants/theme";
import { ReactComponent as DocSVG } from "../../Images/vetDoctor.svg";
import { ReactComponent as PencilSVG } from "../../Images/pencil.svg";
import Api from "../../helpers/apiHelpers";
import UploadPhoto from "../Modals/UploadPhoto";
import {specialities} from "../../Constants/specialities";
import {states} from "../../Constants/locations";
import {getProfileURLUploadImage, getUserProfile, patchUserProfile} from "../../redux/userProfile/userProfile.actions";
import {RootState, useAppDispatch} from "../../redux/store";
import {useSelector} from "react-redux";
import AddLiscenses from "../AddLiscenses";
import ModalImage from "react-modal-image";
import LaunchIcon from "@material-ui/icons/Launch";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import Autocomplete from "@material-ui/lab/Autocomplete";

interface Props {
	setIsOnBoarding: any,
	isOnBoarding: boolean,
}

const useStyle = makeStyles(() => ({
    wrapper: {
        padding: "1.5em"
    },
    inputGrpup: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
    },
    clickable: {
        cursor: "pointer",
    },
    marginLeft: {
        marginLeft: "1em"
    },
    marginBottom: {
        marginBottom: "1em"
    },
    timeWrapper: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        flexWrap: "wrap",
    },
    headerPadding: {
        marginBottom: "1em",
        marginTop: "1em"
    },
    stateFieldStyles: {
        height: 40,
        width: "100%",
        zIndex: 999
    },
    stateInputStyles: {
        width: "100%",
    },
    disallowSpacingVerticalPadding: {
        "& > div": {
            paddingTop: "40px !important",
            paddingBottom: "0px !important",
        }
    },
    workDaysCheckboxLabel: {
        minWidth: 140,
    },
    feeInputs: {
        maxWidth: 100,
        marginRight: "2em",
        marginTop: "1em"
    },
    img: {
        height: 100,
        objectFit: "cover"
    },
    closeIcon: {
        position: "absolute",
        top: -10,
        right: -10,
        zIndex: 99,
        cursor: "pointer"
    }
}));

const Main: SFC<Props> = ({ isOnBoarding, setIsOnBoarding }: Props) => {
    const classes = useStyle();
    const [profileId, setProfileId] = useState();
    const bioTemplate = `With {NUMBER OF YEARS} years of veterinary experience, I am dedicated to delivering compassionate, personalized care for {SPECIES}. My goal is to partner with pet parents by providing practical, evidence-based recommendations that support every stage of their pet’s life. Outside of practice, I share my home with {PETS' NAMES}, who remind me every day why this profession means so much to me.`;
    const [squareAuthButtonVisibility, setSquareAuthButtonVisibility] = useState(false);
    const [isSquareConnected, setIsSquareConnected] = useState(false);
    const [uploadPhotoModalVisibility, setUploadPhotoModalVisibility] = useState(false);
    const [isLoading, setIsloading] = useState(true);
    const [profile, setProfile] = useState(null);
    const [uploadImageURL, setUploadImageURL] = useState("");
    const [initialValues, setInitialValues] = useState({
        firstName: "",
        lastName: "",
        education: "",
        workingStates: [],
        speciality: [],
        brief: bioTemplate,
        image: null,
    });
    const [uploadFile, setUploadFile] = useState(null);
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    const dispatch = useAppDispatch();
    const user = useSelector((state: RootState) => state?.user);
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    let justifyResonsiveStart: GridJustification = isMobile ? "center" : "flex-start";
    const textAlignmentAdaptive: MuIPropTypes.Alignment = isMobile ? "center" : "left";
    const [loaded, setLoaded] = useState(false);
    const [licenses, setLicenses] = useState([]);

    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required("Required"),
        lastName: Yup.string().required("Required"),
    });

    const imageRef = useRef(null);
    const [image, setImage] = useState("");
    const [linkToSquareOauth, setLinkToSquareOauth] = useState("");
    const handleImageLoadError = () => {
        setImage("");
    };

    const handleClickAddState = (values) => {
        setInitialValues({ ...values, workingStates: [...values.workingStates , ""] });
    };

    const handleClickAddSpeciality = (values) => {
        setInitialValues({ ...values, speciality: [...values.speciality , ""] });
    };

    const handleRemoveImage = async (item) => {
        const newList = licenses.filter(license => license !== item);
        setLicenses(newList);
        let imgId = item.split("?")[0].split("/").filter(str => str.includes(".img"))[0].match(/\d+/)[0];
        //Remove license
        const resp = await Api.deleteLicense(profileId,imgId);
    };

    useEffect(() => {
        const parseSquareExist = (res) => {
            if (res === true || res === "true") return true;
            if (res && typeof res === "object") {
                return Boolean(res.exist ?? res.exists ?? res.isExist ?? res.connected);
            }
            return false;
        };

        const loadSquareStatus = () => {
            Api.getSquareOauthExist()
                .then((res) => {
                    setIsSquareConnected(parseSquareExist(res));
                    setSquareAuthButtonVisibility(true);
                })
                .catch(() => {
                    setIsSquareConnected(false);
                    setSquareAuthButtonVisibility(true);
                });
        };

        loadSquareStatus();
        Api.getSquareOauthLink()
            .then((link) => {
                setLinkToSquareOauth(link);
            });

        const onFocus = () => loadSquareStatus();
        window.addEventListener("focus", onFocus);
        return () => window.removeEventListener("focus", onFocus);
    }, []);

    //THIS is to reload the lisense photos
    useEffect(() => {
        if (loaded === true) {
            dispatch(getUserProfile({userId: user.userId}))
                .then((profiles) => {
                    if (profiles.length) {
                        setLicenses(profiles[0].licenseUrl);
                    }
                });
            setLoaded(false);
        }
    }, [loaded]);

    useEffect(() => {
        dispatch(getUserProfile({userId: user.userId}))
            .then((profiles) => {
                if (profiles.length) {
                    setProfile(profiles[0]);
                    setProfileId(profiles[0].id);
                    dispatch(getProfileURLUploadImage(profiles[0].id))
                        .then((res) => {
                            setUploadImageURL(res.uploadUrl);
                            setImage(res.downloadUrl);
                        })
                        .catch((err) => {
                            enqueueSnackbar(err, {variant: "error"});
                        });
                    const newValues = {
                        firstName: profiles[0]?.firstName || "",
                        lastName: profiles[0]?.lastName || "",
                        speciality: profiles[0]?.speciality?.map(el => specialities.find(item => item.value === el)) || [],
                        education: profiles[0]?.education || "",
                        workingStates: profiles[0]?.workingStates?.length ? profiles[0].workingStates.filter(Boolean)  : [""],
                        brief: profiles[0]?.summary?.trim() || bioTemplate,
                        image: profiles[0]?.image || null,
                    };
                    setLicenses(profiles[0].licenseUrl || []);
                    setInitialValues({ ...initialValues, ...newValues });
                }
            });
        setIsloading(false);
    }, []);
    return (
        <Box>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                onSubmit={async (values) => {
                    try {
                        const {
                            workingStates,
                            firstName,
                            lastName,
                            education,
                            brief,
                            speciality
                        } = values;
                        dispatch(patchUserProfile({id: profileId, body: {
                            type: "vet",
                            firstName: firstName,
                            lastName: lastName,
                            education: education,
                            summary: brief,
                            speciality: speciality.map(el => el.value),
                            workingStates: workingStates.filter(Boolean),
                            licenseUrl: licenses
                        }}));
                        enqueueSnackbar("The profile is updated", {variant: "success"});
                        if (isOnBoarding) {
                            setIsOnBoarding(false);
                            history.push({
                                pathname: "/appointments",
                            });
                        }
                    } catch (error) {
                        enqueueSnackbar(error.message || error.message[0], {
                            variant: "error",
                            autoHideDuration: 3000,
                        });
                    }
                }}
                validationSchema={validationSchema}
            >
                {(props) => (
                    isLoading?
                        <Card variant="outlined" className={classes.wrapper}>
                            <Box display="flex" justifyContent="center">
                                <CircularProgress />
                            </Box>
                        </Card>
                        :
                        <Form>
                            <Card variant="outlined" className={classes.wrapper}>
                                <Typography variant="h3" className={classes.headerPadding}>My Profile</Typography>
                                {
                                    squareAuthButtonVisibility && (
                                        isSquareConnected ? (
                                            <Box
                                                display="flex"
                                                alignItems="center"
                                                style={{padding: "12px 0px"}}
                                            >
                                                <Typography style={{paddingRight: 5}}>Square connected</Typography>
                                                <CheckCircleIcon fontSize="small" style={{color: colorPrimary}}/>
                                            </Box>
                                        ) : (
                                            <Button
                                                type="button"
                                                onClick={() => {
                                                    window.open(linkToSquareOauth, "_blank");
                                                }}
                                                style={{display: "flex", alignItems: "center", justifyItems: "center"}}
                                            >
                                                <Typography style={{paddingRight: 5}}>Connect square</Typography>
                                                <LaunchIcon fontSize="small" color="primary"/>
                                            </Button>
                                        )
                                    )
                                }
                                <Grid container>
                                    <Grid item container justify={justifyResonsiveStart} xs={12} sm={4} style={{display: 'flex', alignItems: 'center'}}>
                                        <Box marginBottom="10px" position="relative" display="flex" justifyContent="center">
                                            <Box
                                                position="absolute"
                                                right="-10px"
                                                bottom="-9px"
                                                borderRadius="50%"
                                                bgcolor={colorBorder}
                                                width="21px"
                                                height="21px"
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                className={classes.clickable}
                                                onClick={() => { setUploadPhotoModalVisibility(true); }}
                                            >
                                                <PencilSVG
                                                    color="#3E7D79"
                                                />
                                            </Box>
                                            {image ?
                                                <Card style={{maxWidth: 130}}>
                                                    <img
                                                        alt="vet image"
                                                        ref={imageRef}
                                                        src={image}
                                                        onError={handleImageLoadError}
                                                        width="130"
                                                        height="130"
                                                        style={{objectFit: "cover"}}
                                                    ></img>
                                                </Card> : <DocSVG width="130px" height="130px"/>}
                                        </Box>
                                    </Grid>
                                    <Grid item container alignItems="center" xs={12} sm={8}>
                                        <Grid item container alignItems="center" xs={12} style={{marginBottom: 7}}>
                                            <Typography
                                                variant="h4"
                                                align={textAlignmentAdaptive}
                                                className={`${isMobile ? classes.marginBottom : ""}`}
                                            >
												Name
                                            </Typography>
                                        </Grid>
                                        <Grid item container alignItems="flex-start" xs={12} sm={12}>
                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    component={RTextField}
                                                    variant="outlined"
                                                    name="firstName"
                                                    id="firstName"
                                                    aria-labelledby="First name"
                                                    className={`${isMobile ? classes.marginBottom : ""}`}
                                                    fullWidth={isMobile}
                                                    placeholder=""
                                                    label="First name"
                                                    size="medium"
                                                    onChange={props.handleChange("firstName")}
                                                    onBlur={props.handleBlur("firstName")}
                                                    value={props.values.firstName}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    component={RTextField}
                                                    variant="outlined"
                                                    name="lastName"
                                                    id="lastName"
                                                    aria-labelledby="Last name"
                                                    className={`${isMobile ? classes.marginBottom : classes.marginLeft}`}
                                                    fullWidth={isMobile}
                                                    placeholder=""
                                                    size="medium"
                                                    label="Last name"
                                                    onChange={props.handleChange("lastName")}
                                                    onBlur={props.handleBlur("lastName")}
                                                    value={props.values.lastName}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item container alignItems="center" xs={12} style={{marginTop: 10, marginBottom: 5}}>
                                                <Typography
                                                    variant="h4"
                                                    align={textAlignmentAdaptive}
                                                    className={`${isMobile ? classes.marginBottom : ""}`}
                                                >
													Edu.
                                                </Typography>
                                            </Grid>
                                            <Grid item container alignItems="center" xs={12}>
                                                <Field
                                                    component={TextField}
                                                    variant="outlined"
                                                    name="education"
                                                    id="education"
                                                    aria-labelledby="Education"
                                                    fullWidth
                                                    className={`${isMobile ? classes.marginBottom : ""}`}
                                                    size="medium"
                                                    placeholder="Where did you attend vet school?"
                                                    onChange={props.handleChange("education")}
                                                    value={props.values.education}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid container style={{marginTop: 10}}>
                                    <Grid item container justify={justifyResonsiveStart} className={classes.marginBottom} xs={12}>
                                        <Typography
                                            variant="h4"
                                            align={textAlignmentAdaptive}
                                        >
											Species Treated
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} >
                                        <Autocomplete
                                            multiple
                                            fullWidth={true}
                                            getOptionLabel={(option) => option.label}
                                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                                            options={specialities}
                                            value={specialities.filter(type => props.values.speciality.find(el => el?.value === type?.value)) || []}
                                            onChange={(event, value) => {
                                                props.setFieldValue("speciality", value);
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container style={{marginTop: 10}}>
                                    <Grid item container justify={justifyResonsiveStart} className={classes.headerPadding} xs={12}>
                                        <Typography
                                            variant="h4"
                                            align={textAlignmentAdaptive}
                                        >
											Licensed State(s)
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} >
                                        <Autocomplete<{label: string, value: string}, true, false, false>
                                            multiple
                                            fullWidth={true}
                                            getOptionLabel={(option) => option.label}
                                            getOptionSelected={(option, value) => option.value === value.value}
                                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                                            options={states}
                                            value={states.filter(state => props.values.workingStates.includes(state.value)) || []}
                                            onChange={(event, value) => {
                                                props.setFieldValue("workingStates", value.map(el => el.value));
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item container justify={justifyResonsiveStart} className={classes.headerPadding} xs={12}>
                                        <Typography
                                            variant="h4"
                                            align={textAlignmentAdaptive}
                                        >
											Bio
                                        </Typography>
                                    </Grid>
                                <Grid container >
                                    <Grid item container justify="center" xs={12}>
                                        <Field
                                            component={TextField}
                                            variant="outlined"
                                            id="brief"
                                            aria-labelledby="Bio"
                                            multiline
                                            rows={6}
                                            fullWidth
                                            name="brief"
                                            onChange={props.handleChange("brief")}
                                            value={props.values.brief}
                                            helperText="Replace only the text inside the { } brackets and remove the { } brackets."
                                        />
                                    </Grid>
                                </Grid>
                                <Typography variant="h4" style={{marginTop: 10, marginBottom: 4}}>Active License(s)</Typography>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    style={{ marginBottom: 12, fontWeight: 400 }}
                                >
                                    Please upload certificate(s) of your license(s) of good standing for all relevant states.
                                </Typography>
                                <Box display="flex" flexWrap="wrap" justifyContent="space-between" className={classes.marginBottom}>
                                    {licenses.map((item) => {
                                        return (
                                            <Box height="120px" key={item} position="relative">
                                                <CancelIcon className={classes.closeIcon} color="error" onClick={() => handleRemoveImage(item)}/>
                                                <ModalImage
                                                    small={item}
                                                    large={item}
                                                    className={classes.img}
                                                />
                                            </Box>

                                        );
                                    })}
                                    {profileId &&
										<AddLiscenses vetId={profileId} profile={profile} setLoaded={setLoaded}/>
                                    }
                                </Box>
                                <Box display="flex" justifyContent="flex-end" style={{marginTop:10}}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        style={{
                                            backgroundColor: colorSecondary,
                                            color: colorfff,
                                        }}
                                        type="submit">
                                        Save
                                    </Button>
                                </Box>
                            </Card>
                        </Form>
                )}
            </Formik>
            {
                uploadImageURL &&
				<UploadPhoto
				    onClose={() => { setUploadPhotoModalVisibility(false); }}
				    isOpen={uploadPhotoModalVisibility}
				    imageUploadURL={uploadImageURL}
				    onLoad={(val) => {
				        setUploadFile(val);
				        setUploadPhotoModalVisibility(false);
				        dispatch(getProfileURLUploadImage(profileId))
				            .then((res) => {
				                setUploadImageURL(res.uploadUrl);
				                setImage(res.downloadUrl);
				            })
				            .catch((err) => {
				                enqueueSnackbar(err, {variant: "error"});
				            });
				    }}
				/>
            }
        </Box>
    );
};

export default Main;
